<template>
    <div>

        <vue-headful title="Changelogs :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item active"><i class="fa fa-code"></i> Changelogs</li>
                <li class="ml-3" v-if="this.$store.state.user.is_admin && this.$store.state.user.is_dev == 1">
                    <router-link :to="`/changelogs/create`" class="btn btn-sm btn-success"><i class="fa fa-plus-circle"></i> Create</router-link>
                </li>
            </ol>
        </h4>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="safetyMeetingTable" url="/changelogs/list" :columns="columns" :options="options">

                    <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                    </div>

                    <div slot="afterFilter" class="ml-2">

                    </div>

                    <template slot="id" slot-scope="props">
                        <router-link :to="`/changelogs/view/${props.row.id}`" title="View Changelog" class="btn btn-sm btn-secondary">
                            View
                        </router-link>
                    </template>

                    <template slot="changelog_title" slot-scope="props">
                        <router-link :to="`/changelogs/view/${props.row.id}`" title="View Changelog">
                            {{ props.row.changelog_title }}
                        </router-link>
                    </template>

                    <template slot="changelog_type_name" slot-scope="props">
                        <label :class="`badge badge-${props.row.label_color}`">{{ props.row.changelog_type_name }}</label>
                    </template>

                    <router-link slot="released_at" slot-scope="props" :to="`/changelogs/view/${props.row.id}`" title="View Changelog">
                        <template v-if="props.row.released_at">{{ props.row.released_at | moment("MM/DD/YYYY") }}</template>
                    </router-link>

                </v-server-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                options: {
                    headings: {
                        id: 'Actions',
                        changelog_title: 'Title',
                        changelog_type_name: 'Type',
                        released_at: 'Released',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'changelogs.released_at',
                    },
                    requestAdapter: (data) => {
                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },
                columns: ['id', 'changelog_title', 'changelog_type_name', 'released_at'],
            }
        },

        computed: {

        },

        methods: {

        },
    }
</script>
